import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import friendinvite from "../assets/images/Homepagesec/Homepageroundimgs/homecasualgame.png";
import frnbbg from "../assets/images/Homepagesec/casualsec.jpg"; // background image

const CasualGames = () => {
  const { t } = useTranslation();

  return (
    <div
      className="text-center pt-16 px-4 overflow-hidden"
      style={{
        backgroundImage: `url(${frnbbg})`,
        backgroundColor: "#070b28",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        backgroundPosition: "bottom 15px center",
        paddingBottom: "100px",
      }}
    >
      <h2 className="text-[48px] font-oswald font-extrabold text-white">
        {t("casualgames.title")}
      </h2>

      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-6 w-[120px] h-auto"
      />

      {/* <p className="text-[16px] md:text-[18px] font-proxima font-medium text-[#ffffff] leading-relaxed">
        {t("casualgames.tagline")}
      </p> */}

      <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 px-4 md:px-12">
        {/* Left side: TEXT */}
        <p className="text-[20px] md:text-[24px] font-oswald font-semibold max-w-xl text-center md:text-left text-white">
                {t("casualgames.tagline")}
        </p>

        {/* Right side: IMAGE */}
        <img
          src={friendinvite}
          alt={t("casualgames.inviteImageAlt")}
          className="w-full max-w-[300px] md:max-w-[400px] h-auto"
        />
      </div>
    </div>
  );
};

export default CasualGames;
